(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aside"] && !Shopify.designMode) return;
  try {
    // 多方向可重复侧边栏
class Pushbar {
    constructor(config = { overlay: true, blur: false }) {
        this.activeId;
        this.activeElement;
        this.overlayElement;
        if (config.overlay) {
            this.overlayElement = document.createElement('div');
            this.overlayElement.classList.add('pushbar_overlay');
            document.querySelector('body').appendChild(this.overlayElement);
        }
        if (config.blur) {
            const mainContent = document.querySelector('.pushbar_main_content');
            if (mainContent) {
                mainContent.classList.add('pushbar_blur');
            }
        }
        this.bindEvents();
    }

    emitOpening() {
        const event = new CustomEvent('pushbar_opening', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } });
        this.activeElement.dispatchEvent(event);
    }

    emitClosing() {
        const event = new CustomEvent('pushbar_closing', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } });
        this.activeElement.dispatchEvent(event);
    }

    handleOpenEvent(e) {
        e.preventDefault();
        const pushbarId = e.currentTarget.getAttribute('data-pushbar-target');
        this.open(pushbarId);
    }

    handleCloseEvent(e) {
        e.preventDefault();
        this.close();
    }

    handleKeyEvent(e) {
        if (e.keyCode === 27) this.close();
    }

    bindEvents() {
        const triggers = document.querySelectorAll('[data-pushbar-target]');
        const closers = document.querySelectorAll('[data-pushbar-close]');
        triggers.forEach(trigger => trigger.addEventListener('click', e => this.handleOpenEvent(e), false));
        closers.forEach(closer => closer.addEventListener('click', e => this.handleCloseEvent(e), false));
        if (this.overlayElement) {
            this.overlayElement.addEventListener('click', e => this.handleCloseEvent(e), false);
        }
        document.addEventListener('keyup', e => this.handleKeyEvent(e));
    }

    open(pushbarId, dom = null, fn) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (this.activeId === String(pushbarId) || !pushbarId) return;
        if (this.activeId && this.activeId !== String(pushbarId)) this.close();
        this.activeId = pushbarId
        this.activeElement = document.querySelector(`[data-pushbar-id="${this.activeId}"]`)
        if (!this.activeElement) return;
        this.emitOpening();
        if (dom) {
            const contentBox = this.activeElement.hasAttribute('data-content') ? this.activeElement : this.activeElement.querySelector('[data-content]');
            if (contentBox) {
                if (dom instanceof DocumentFragment || dom instanceof Node) {
                    contentBox.innerHTML = '';
                    contentBox.append(dom); // DOM → append
                } else {
                    contentBox.innerHTML = dom; // 字符串 → innerHTML
                }
            }
        }
        this.activeElement.classList.add('watt-opened');
        const pageRootElement = document.querySelector('html')
        pageRootElement.classList.add('pushbar_locked');
        pageRootElement.setAttribute('pushbar', pushbarId)
        pageRootElement.style.paddingRight = scrollbarWidth + 'px'
        if(typeof fn === 'function'){fn(this.activeElement)}
    }

    close() {
        if (!this.activeId) return;
        this.emitClosing();
        this.activeElement.classList.remove('watt-opened');
        const contentBox = this.activeElement.querySelector('[data-content]')
        if(contentBox) {contentBox.textContent = ''}
        const pageRootElement = document.querySelector('html')
        pageRootElement.classList.remove('pushbar_locked');
        pageRootElement.removeAttribute('pushbar')
        pageRootElement.style.paddingRight = 0
        this.activeId = null;
        this.activeElement = null;

    }
}

// 初始化弹窗
const pushbar = new Pushbar({blur: true,overlay: true})
window.wattPushbar = pushbar

// 初始化关闭点击事件
const asideLeft = document.querySelector('[data-pushbar-id="left"]');
const asideRight = document.querySelector('[data-pushbar-id="right"]');
const asideBottom = document.querySelector('[data-pushbar-id="bottom"]');
asideLeft.addEventListener('click', function (e) {
  if (e.target.closest('[data-pushbar-close]')) {window.wattPushbar.close('left')}
});
asideRight.addEventListener('click', function (e) {
  if (e.target.closest('[data-pushbar-close]')) {window.wattPushbar.close('right')}
});
asideBottom.addEventListener('click', function (e) {
  if (e.target.closest('[data-pushbar-close]')) {window.wattPushbar.close('bottom')}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-countdown-timer"] && !Shopify.designMode) return;
  try {
    function init() {
    const closeBtn = document.querySelector('.watt-header__cdtm-close');
    if(!closeBtn) return;
    const headerCountdownTimer = sessionStorage.getItem('header_countdown_timer');
    if (headerCountdownTimer === 'closed') {
        closeBtn.closest('.watt-header__cdtm').style.display = 'none';
    } else {
        closeBtn.closest('.watt-header__cdtm').style.display = 'flex';
    }
    closeBtn.addEventListener('click', function() {
        this.closest('.watt-header__cdtm').style.display = 'none';
        sessionStorage.setItem('header_countdown_timer', 'closed');
        document.dispatchEvent(new Event('header-height-changed'));
    });
    document.dispatchEvent(new Event('header-height-changed'));
}
document.addEventListener('DOMContentLoaded', init);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    window.wattcycle_modal = {
        open,
        close
    }
    const modal = document.querySelector('.watt-modal');
    const contentBox = document.querySelector('.watt-modal__content');
    const closeBtn = document.querySelector('.watt-modal__close');
    let scrollY = 0; // 记录打开前的滚动位置

    // 打开弹窗
    function open(dom) {
        if(!dom) return
        contentBox.innerHTML = '';
        contentBox.append(dom)
        scrollY = window.scrollY;
        document.body.classList.add('watt-modal--active');
        document.body.style.top = `-${scrollY}px`;
        modal.classList.add('active');
        // 自动聚焦可交互元素
        const firstInput = modal.querySelector('input')
        const firstBtn = modal.querySelector('button')
        setTimeout(function () {
            if (firstInput) {
                firstInput.focus();
            } else if (firstBtn) {
                firstBtn.focus();
            }
        }, 100)
    }

    // 关闭弹窗
    function close() {
        modal.classList.remove('active');
        contentBox.innerHTML = '';
        document.body.classList.remove('watt-modal--active');
        document.body.style.top = '';
        
        // 取消css默认的平滑滚动
        const html = document.documentElement;
        const originalBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';

        window.scrollTo(0, scrollY, 'auto');

        setTimeout(() => {
            html.style.scrollBehavior = originalBehavior;
        }, 50);
    }

    // 事件绑定
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            close();
        }
    });

    // Esc 键关闭
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
            close();
        }
    });

    // 可选：焦点捕获（Tab 键在弹窗内循环）
    modal.addEventListener('keydown', e => {
        if (e.key === 'Tab') {
            const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }
    });
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prod-card"] && !Shopify.designMode) return;
  try {
    const iconItems = document.querySelectorAll('.wt-n__prod-icon-item');
iconItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
        e.preventDefault();
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-table-js"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-watt-content] table').forEach((table) => {
    if (table.getAttribute('data-watt-content') === 'true') {
      return;
    }
    const wrapper = document.createElement('div');
    wrapper.className = 'watt-content__scroll-table';
    table.parentNode.insertBefore(wrapper, table);
    table.setAttribute('data-watt-content', 'true');
    wrapper.appendChild(table);
  });
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  var root = document.getElementById('watt-toast');
  if (!root) return;

  function removeToast(item) {
    var id = item.getAttribute('data-timeout-id');
    if (id) {
      clearTimeout(Number(id));
    }
    item.classList.remove('watt-toast__item--visible');
    setTimeout(function() {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    }, 250);
  }

  window.wattToast = function(type, message, duration) {
    var allowed = ['success', 'error', 'warning', 'info'];
    if (allowed.indexOf(type) === -1) {
      type = 'info';
    }

    var dur = typeof duration === 'number' ? duration : 3000;

    var item = document.createElement('div');
    item.className = 'watt-toast__item watt-toast--' + type;

    item.innerHTML =
      '<div class="watt-toast__inner">' +
        '<span class="watt-toast__icon" aria-hidden="true"></span>' +
        '<span class="watt-toast__message"></span>' +
        '<button type="button" class="watt-toast__close" aria-label="Turn off notifications">&times;</button>' +
      '</div>';

    var msgEl = item.querySelector('.watt-toast__message');
    msgEl.textContent = message;

    root.appendChild(item);

    requestAnimationFrame(function() {
      item.classList.add('watt-toast__item--visible');
    });

    if (dur > 0) {
      var timeoutId = window.setTimeout(function() {
        removeToast(item);
      }, dur);
      item.setAttribute('data-timeout-id', String(timeoutId));
    }
  };

  root.addEventListener('click', function(event) {
    var closeBtn = event.target.closest('.watt-toast__close');
    if (!closeBtn) return;

    var item = closeBtn.closest('.watt-toast__item');
    if (!item) return;

    removeToast(item);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-cover-js"] && !Shopify.designMode) return;
  try {
    function initClickOpenVideoModal(container) {
    if(container && container.addEventListener) {
        container.addEventListener('click', function (e) {
            
            const item = e.target.closest('[data-vdo-wrap]');
            if (item && container.contains(item)) {
                const template = item.querySelector('template');
                if (template) {
                    e.stopPropagation();
                    const domNode = template.content.cloneNode(true);
                    // 3. 传入 DOM 节点而不是 HTML 字符串
                    if (window?.wattcycle_modal) {
                        window.wattcycle_modal.open(domNode);
                    }
                } else {
                    console.warn('No template found in clicked item:', item);
                }
            }
        });
    }
}

document.addEventListener('wt:vdo:list:init', function (data) {
    if (data && data.detail) {
        const root = data.detail?.root || null;
        if(root) {
            initClickOpenVideoModal(root);
        }
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["watt-global-menu-widget"] && !Shopify.designMode) return;
  try {
    if (customElements.get('wt-global-menu-widget')) return;

    class WtGlobalMenuWidget extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
      }

      connectedCallback() {
        var dataScript = document.getElementById('wt-global-menu-data');
        if (!dataScript) return;

        var parsed;
        try {
          parsed = JSON.parse(dataScript.textContent);
        } catch (e) {
          return;
        }

        var current = parsed.current || {};
        var sites = parsed.sites || [];

        var style = document.createElement('style');
        style.textContent = `
          :host {
            line-height: 0;
          }
          .menu {
            position: relative;
            display: inline-block;
            --flag-width: 20px;
            --flag-radius: 2px;
            --font-color: inherit;
          }
          .menu .main {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius: 50%;
            overflow: hidden;
          }
          .menu .main:hover {
            background: rgba(0, 0, 0, 0.1);
          }
          .main-flag {
            border-radius: var(--flag-radius);
            width: var(--flag-width);
            aspect-ratio: 1;
            object-fit: cover;
          }
          .menu.active .dropdown {
            display: block;
          }
          .dropdown {
            position: absolute;
            top: 120%;
            right: 0;
            background: #ffffff;
            display: none;
            min-width: 100%;
            max-width: 400px;
            border-radius: 5px;
            overflow: hidden;
            color: var(--font-color);
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
            z-index: 5;
          }
          .dropdown .link {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 15px;
            color: #000000;
            text-decoration: none;
            border-bottom: 1px solid rgba(0, 0, 0, 0.04);
          }
          .dropdown .link:last-child {
            border-bottom: none;
          }
          .dropdown .link:hover {
            background: rgba(0, 0, 0, 0.05);
          }
          .dropdown .flag {
            border-radius: var(--flag-radius);
            width: var(--flag-width);
            margin: 0;
            padding: 0;
          }
          .dropdown .name {
            font-size: 16px;
            font-weight: 400;
            line-height: 1;
            white-space: nowrap;
          }
          .main:after {
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            top: 20%;
            left: 0;
          }
          @media (max-width: 900px) {
            :host {
              padding: 0 1.5em;
            }
            .dropdown .name {
              font-size: 14px;
            }
            .menu .main {
              padding: 0;
              background: rgba(0, 0, 0, 0);
              box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
            }
            .main-flag {
              width: 20px;
            }
            .dropdown .link {
              padding: 10px 15px;
              border-bottom: 1px solid rgba(0,0,0, 0.04);
            }
          }
        `;

        var container = document.createElement('div');
        container.className = 'menu';
        container.innerHTML = ''
          + '<div class="main">'
          +   '<img class="main-flag" loading="lazy" alt="">'
          + '</div>'
          + '<div class="dropdown"></div>';

        var mainFlag = container.querySelector('.main-flag');
        if (mainFlag && current && current.flag) {
          mainFlag.src = current.flag;
          if (current.country) {
            mainFlag.alt = current.country;
          }
        }

        var dropdown = container.querySelector('.dropdown');
        if (dropdown && Array.isArray(sites)) {
          sites.forEach(function(site) {
            if (!site || !site.url) return;

            var link = document.createElement('a');
            link.className = 'link';
            link.href = site.url;

            var img = document.createElement('img');
            img.className = 'flag';
            img.loading = 'lazy';
            if (site.flag) img.src = site.flag;
            if (site.country) img.alt = site.country;

            var span = document.createElement('span');
            span.className = 'name';
            span.textContent = site.country || '';

            link.appendChild(img);
            link.appendChild(span);
            dropdown.appendChild(link);
          });
        }

        this.shadowRoot.appendChild(style);
        this.shadowRoot.appendChild(container);

        var globalBtn = container.querySelector('.main');
        if (!globalBtn) return;

        globalBtn.addEventListener('click', function(event) {
          event.stopPropagation();
          container.classList.toggle('active');
        });

        document.addEventListener('click', function(event) {
          if (!container.contains(event.target)) {
            container.classList.remove('active');
          }
        });
      }
    }

    customElements.define('wt-global-menu-widget', WtGlobalMenuWidget);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["watt-language-switch-widget"] && !Shopify.designMode) return;
  try {
    class WattLocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul')
    };
    if (!this.elements.button || !this.elements.panel || !this.elements.input) return;

    

    this.openSelector = this.openSelector.bind(this);
    this.closeSelector = this.closeSelector.bind(this);
    this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
    this.onItemClick = this.onItemClick.bind(this);

    this.elements.button.addEventListener('click', this.openSelector);
    this.elements.button.addEventListener('focusout', this.closeSelector);
    this.addEventListener('keyup', this.onContainerKeyUp);
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    var value = event.currentTarget.dataset.value;
    if (!value) return;
    var form = this.querySelector('form');
    this.elements.input.value = value;
    if (form) form.submit();
  }

  openSelector() {
    var expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      this.hidePanel();
    } else {
      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.button.focus();
    }
  }

  closeSelector(event) {
    var related = event.relatedTarget;
    var shouldClose = !related || related.nodeName === 'BUTTON';
    if (shouldClose) {
      this.hidePanel();
    }
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('watt-localization-form', WattLocalizationForm);
}
  } catch(e) { console.error(e); }
})();

})();
